import React, {useState} from 'react';
import BingCategorySelector from "../../../../services/categories/BingCategorySelector";
import {UncontrolledTooltip} from "reactstrap";

function BulkLocationEditorBing ({
                                   setFormIsInvalid,
                                   singleLocationMode,
                                   locationPatch,
                                   mergeIntoLocationPatch,
                                   bingCategoriesStore,
                                   updateBingCategories,
                                   updatePrimaryBingCategory
}) {

  const [bingCategoriesErrorMessage, setBingCategoriesErrorMessage] = useState(null);

  const handleBingCategoriesUpdate = (selected) => {
    if (selected.length <= 3) {
      updateBingCategories(selected);
      setBingCategoriesErrorMessage(null)
    } else {
      setBingCategoriesErrorMessage("Select up to 3 Bing categories.")
    }
  }

  const setTrackingNumber = (e) => {
    const trackingNumber = e.target.value;
    mergeIntoLocationPatch({
      "listingManagementSpecs": {
        "providerTrackingNumbers": {
          "BING": trackingNumber
        }
      }
    })

  };

  const setTrackingUrl = (e) => {
    const trackingUrl = e.target.value;
    mergeIntoLocationPatch({
      "listingManagementSpecs": {
        "providerTrackingWebsiteUrls": {
          "BING": trackingUrl
        }
      }
    })
  };

  // Require Bing Primary Category for single locations
  setFormIsInvalid(singleLocationMode && !locationPatch.listingManagementSpecs.primaryBingCategory);

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Bing Category{!!singleLocationMode && "*"}</h5>
    <div className="row card-spacer-top">
      <div className="col-12 col-sm-12">
        <BingCategorySelector
          multi={false}
          selected={!!locationPatch.listingManagementSpecs.primaryBingCategory ? [locationPatch.listingManagementSpecs.primaryBingCategory] : []}
          bingCategoriesStore={bingCategoriesStore}
          onSelect={updatePrimaryBingCategory}
        />
        {bingCategoriesErrorMessage ? <div className="invalid-feedback" style={{"display": "block"}}>{bingCategoriesErrorMessage}</div> : <div className="invalid-feedback" style={{"opacity": "0", "display": "block"}}>line spacer</div>}
      </div>
    </div>

    <h5>Additional Bing Categories</h5>
    <div className="row card-spacer-top">
      <div className="col-12 col-sm-12">
        <BingCategorySelector
          multi={true}
          selected={locationPatch.listingManagementSpecs.bingCategories}
          bingCategoriesStore={bingCategoriesStore}
          onSelect={handleBingCategoriesUpdate}
        />
        {bingCategoriesErrorMessage ? <div className="invalid-feedback" style={{"display": "block"}}>{bingCategoriesErrorMessage}</div> : <div className="invalid-feedback" style={{"opacity": "0", "display": "block"}}>line spacer</div>}
      </div>
    </div>

    <h5 className="content-spacer-top">Call Tracking Number</h5>
    <div className="row card-spacer-top">
      <div className="col-12">
        <input
          disabled={!singleLocationMode}
          type="text"
          id="googleTrackingPhone"
          placeholder="Tracking Phone Number"
          maxLength={155}
          value={locationPatch.listingManagementSpecs.providerTrackingNumbers.BING || ''}
          onChange={setTrackingNumber}
          className={"form-control text-input" + (!singleLocationMode ? " cursor-not-allowed" : "")}
        />
        {!singleLocationMode && <UncontrolledTooltip target="googleTrackingPhone">
          Call Tracking Number can only be edited for single locations.
        </UncontrolledTooltip>}
      </div>
    </div>

    <h5 className="card-spacer-top">UTM/Tracking Website URL</h5>
    <div className="row card-spacer-top">
      <div className="col-12">
        <input
          type="url"
          id="facebookTrackingUrl"
          placeholder="Tracking Url"
          maxLength={155}
          value={locationPatch.listingManagementSpecs.providerTrackingWebsiteUrls.BING}
          onChange={setTrackingUrl}
          className="form-control text-input"
        />
      </div>
    </div>
  </div>
}

export default BulkLocationEditorBing;